﻿export class response_login_contact {
    public contact_id: string = "";
    public first_name: string = "";
    public second_name: string = "";
    public email: string = "";
}